import React, { useState } from 'react';
import { Box, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Topbar from '../common/Topbar';
import Sidebar from '../common/Sidebar';

const drawerWidth = 260;

const MainLayout = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const theme = useTheme();
    // Ensure that in desktop, the sidebar is permanent, so we don't open the temporary drawing by mobileOpen being true.
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', '@media print': { minHeight: 'auto', display: 'block' } }}>
            <Box sx={{ '@media print': { display: 'none' } }}>
                <Topbar handleDrawerToggle={handleDrawerToggle} />
            </Box>
            <Box sx={{ '@media print': { display: 'none' } }}>
                <Sidebar
                    drawerWidth={drawerWidth}
                    mobileOpen={isDesktop ? false : mobileOpen}
                    handleDrawerToggle={handleDrawerToggle}
                />
            </Box>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: { xs: 3, print: 0 },
                    bgcolor: { xs: '#f5f6fa', print: '#fff' },
                    width: { sm: `calc(100% - ${drawerWidth}px)`, print: '100%' },
                }}
            >
                <Toolbar sx={{ '@media print': { display: 'none' } }} /> {/* Spacer below the Topbar */}
                <Outlet />
            </Box>
        </Box>
    );
};

export default MainLayout;
